export async function retry(
    fn,
    { attempts = 3, delayMs = 300 } = {}
  ) {
    let lastError = null;
  
    for (let i = 1; i <= attempts; i++) {
      try {
        const result = await fn();     
        if (result) return result;     
      } catch (err) {
        lastError = err;               
      }
  
      if (i < attempts) {
        await new Promise((r) => setTimeout(r, delayMs * i)); 
      }
    }
  
    throw lastError ?? new Error("NETWORK_RETRY_EXHAUSTED");
  }
  